import { validationTypes } from "../../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";
import { GridColumnType } from "../../../../../../data/gridColumnType";


const initState = {
  title: "",
  description: "",
};

export const NewTaskBugConfig = {
  name: "Bug Form",
  initialState: initState,
  section: [
    {
      sectionId: 'bugForm',
      title: "Bug Form",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "title",
          label: "Bug Title",
          Field_Name: "Bug Title",
          fieldType: FormFieldTypes.INPUT,
          dataField: "title",
          fieldSetting: {
            placeholder: "Enter Bug Title",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "description",
          label: "Bug Description",
          Field_Name: "email body",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "description",
          fieldSetting: {
            placeholder: "Enter Bug Detail",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-6 mb-2 bug-body-height",
          },
        }
      ]
    }
  ]
}

export const GridConfig = {
  columns: [
    {
      name: "Bug Id",
      fieldName: "taskId",
    },
    {
      name: "Bug Title",
      fieldName: "title",
    },
    {
      name: "Status",
      fieldName: "statusName",
    },
    {
      name: "Priority",
      fieldName: "priorityName",
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};
